import React from 'react'
import RaisedButton from 'material-ui/RaisedButton'
import Background from '../Background'
import './welcome.css'
import Links from '../../router/links'

export default ({greeting}) => {

    return (
        <div>
            <Background />
            <div className="welcome-container">
                <h1>{greeting}</h1>
            </div>
        </div>
    );

};


/** WEBPACK FOOTER **
 ** ./src/app/components/Welcome/index.js
 **/